import { SecurityProvider } from '@pjn/core/security'
import Keycloak from '../keycloak/'

export const securityProvider: SecurityProvider = new Keycloak({
  clientId: process.env.VUE_APP_pjn-denuncias || '',
  realm: process.env.VUE_APP_pjn || '',
  url: process.env.VUE_APP_https://sso.pjn.gov.ar/auth || ''
})
